.dropzone {
  background: rgb(var(--color-white), 0.6);
  position: absolute;
  inset: 0;
  outline: 1px dashed #979797;
  outline-offset: -1px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.isDragActive {
    outline: 2px dashed #673ab7;
    outline-offset: -2px;
  }
}

.label {
  text-align: center;
  font-size: 18px;
  font-weight: var(--font-weight-bold);
}

.link {
  color: #673ab7;
  cursor: pointer;
}
